
const HTTP_STATUS = {
  OK: 200,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
};

function addAuthorizationHeader(headers) {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const username = sessionStorage.getItem("username") || '';
    if (username) {
      const password = sessionStorage.getItem("password") || '';
      headers["Authorization"] = 'Basic ' + window.btoa(username + ":" + password);
    }
  } else {
    console.error("sessionStorage non disponibile.");
  }
}

function getHeaderJson() {
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
  };
  addAuthorizationHeader(headers);
  return headers;
}

function getHeaderPdf() {
  let headers = {
    "Accept": "application/pdf"
  };
  addAuthorizationHeader(headers);
  return headers;
}


function getHeaderMultipart() {
  const headers = {};
  addAuthorizationHeader(headers);
  return headers;
}

function getJsonMethod() {
  return {
    method: "GET",
    headers: getHeaderJson(),
  };
}

export function getFromApi(url, okAction, errorAction) {
  fetch(url, getJsonMethod())
    .then(response => {
      var data;
      switch (response.status) {
        case HTTP_STATUS.OK:
          if (response.headers.get("Content-Type") === "text/csv") {
            data = {
              ok: true,
              content: response.blob()
            };
          } else {
            data = response.json();
          }
          break;
        case HTTP_STATUS.UNAUTHORIZED:
          data = { ok: false, messaggi: [{ tipo: "warning", descrizione: "accesso non autorizzato" }] };
          break;
        case HTTP_STATUS.NOT_FOUND:
          data = { ok: false, messaggi: [{ tipo: "warning", descrizione: "La risorsa richiesta non è stata trovata" }] };
          break;
        default:
          data = { ok: false, messaggi: [{ tipo: "warning", descrizione: `Codice errore ${response.status}` }] };
          break;
      }
      return data;
    })
    .then((data) => {
      if (data.ok) {
        if (okAction) okAction(data);
      } else {
        if (errorAction) errorAction(data);
      }
    })
    .catch(errore => {
      console.log("errore get", url, errore);
      errorAction({
        ok: false,
        messaggi: [{ tipo: "danger", descrizione: "si è verificato un errore: contattare l'assistenza" }]
      })
    });
}

/**
 * Scarica un file generico dal server.
 * Estrae il nome file dall'header Content-Disposition se disponibile.
 * @param {string} url - URL del file da scaricare
 * @param {string} defaultFilename - Nome file di default se non specificato nel server
 */
export function downloadFile(url, defaultFilename) {
  fetch(url, {
    method: "GET",
    headers: getHeaderPdf()
  }).then(response => {
    // Estrai il nome del file dall'header Content-Disposition se disponibile
    const contentDisposition = response.headers.get("content-disposition");
    let filename = defaultFilename;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/["']/g, "");
      }
    }
    
    return response.blob().then(blob => ({ blob, filename }));
  }).then(({ blob, filename }) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }).catch((error) => {
    console.log("error", error)
  });
}

/**
 * Scarica un file CSV dal server.
 * Retrocompatibilità - usa downloadFile internamente.
 * @param {string} url - URL del file CSV da scaricare
 * @param {string} filename - Nome file (opzionale, verrà sovrascritto se il server specifica un nome)
 */
export function downloadCsv(url, filename) {
  downloadFile(url, filename || "download.csv");
}


export function postToApi(url, request, okAction, errorAction) {
  const body = JSON.stringify(request);
  fetch(url, {
    method: "POST",
    headers: getHeaderJson(),
    body: body,
  })
    .then(response => response.json())
    .then(data => {
      if (data.ok) {
        if (okAction) okAction(data);
      } else {
        if (errorAction) errorAction(data);
      }
    })
    .catch(errore => {
      console.log("errore post", url, errore)
      errorAction({
        ok: false,
        messaggi: [{ tipo: "danger", descrizione: "si è verificato un errore: contattare l'assistenza" }]
      })
    });
}

export function postMultipartToApi(url, request, okAction, errorAction) {
  fetch(url, {
    method: "POST",
    headers: getHeaderMultipart(),
    body: request,
  })
    .then(response => response.json())
    .then(data => {
      if (data.ok) {
        if (okAction) okAction(data);
      } else {
        if (errorAction) errorAction(data);
      }
    })
    .catch(errore => {
      console.log("errore multipart", url, errore)
      errorAction({
        ok: false,
        messaggi: [{ tipo: "danger", descrizione: "si è verificato un errore: contattare l'assistenza" }]
      })
    });
}

/**
 * Invia una richiesta multipart e gestisce sia risposte JSON che file da scaricare
 * @param {string} url - URL dell'endpoint
 * @param {FormData} formData - Dati del form da inviare
 * @param {string} defaultFilename - Nome file di default per il download
 * @param {function} okAction - Callback per successo JSON
 * @param {function} errorAction - Callback per errore
 * @param {function} fileDownloadAction - Callback chiamato quando viene scaricato un file
 */
export function postMultipartWithFileResponse(url, formData, defaultFilename, okAction, errorAction, fileDownloadAction) {
  fetch(url, {
    method: "POST",
    headers: getHeaderMultipart(),
    body: formData,
  })
    .then(response => {
      // Controlla il tipo di contenuto della risposta
      const contentType = response.headers.get("content-type");
      
      if (contentType && (
          contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
          contentType.includes("application/vnd.ms-excel") ||
          contentType.includes("text/csv")
        )) {
        // È un file da scaricare
        return response.blob().then(blob => {
          // Estrai il nome del file dall'header Content-Disposition se disponibile
          const contentDisposition = response.headers.get("content-disposition");
          let filename = defaultFilename;
          
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/["']/g, "");
            }
          }
          
          // Scarica il file
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          
          // Chiama il callback per il download del file
          if (fileDownloadAction) {
            fileDownloadAction({
              ok: true,
              filename: filename,
              message: "File scaricato con successo"
            });
          }
        });
      } else if (contentType && contentType.includes("application/json")) {
        // È una risposta JSON normale
        return response.json().then(data => {
          if (data.ok) {
            if (okAction) okAction(data);
          } else {
            if (errorAction) errorAction(data);
          }
        });
      } else {
        // Gestione errore HTTP
        throw new Error(`Risposta non gestita. Status: ${response.status}, Content-Type: ${contentType}`);
      }
    })
    .catch(errore => {
      console.log("errore multipart con file response", url, errore);
      if (errorAction) {
        errorAction({
          ok: false,
          messaggi: [{ tipo: "danger", descrizione: "Si è verificato un errore durante l'elaborazione del file" }]
        });
      }
    });
}
